<template>
    <div>
        <slot v-bind:selectFile="selectFile" v-bind:loading="loading"></slot>
        <input v-on:change="upload" type="file" class="tw-hidden" ref="field">
    </div>
</template>
<script>
    export default {
        data: v => ({
            loading: false,
        }),
        methods: {
            selectFile() {
                this.$refs.field.click()
            },
            upload() {
                this.loading = true
                let formData = new FormData
                formData.append('image', this.$refs.field.files[0])
                console.log(formData)
                axios.post('/api/upload/user/cover', formData, {
                    params: {token: window.jwt_token}
                })
                    .then(resp => {
                        refreshUser()
                        this.$toast.success(resp.data.msg)
                    })
                    .finally(() => this.loading = false)
            }
        }
    }
</script>
